import {Payment} from './payment';
import {Address} from './address';

export class Customer {
    name: string;
    last_name: string;
    second_last_name: string;
    phone_number: string;
    email: string;
    document_type: number;
    document: string;
    nationality: string;
    birth_date: string;
    gender: string;
    company_name?: string;
    payment = new Payment();
    billing_address = new Address();
}
